import * as React from "react";
function SvgIcCancel(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.156 7.063l-4.8 4.8-4.78-4.778-.53.53 4.78 4.778-4.757 4.756.53.531 4.757-4.756 4.778 4.779.53-.53-4.778-4.78 4.8-4.8-.53-.53z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcCancel;
